function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.08882 12.4556L1.11783 5.65809C0.960722 5.50492 0.960722 5.25637 1.11783 5.1032L2.9801 3.28725C3.13818 3.1331 3.39307 3.1331 3.55015 3.28725L8.37335 7.99039L16.4498 0.114879C16.6069 -0.038293 16.8618 -0.038293 17.0199 0.114879L18.8822 1.93084C19.0393 2.08401 19.0393 2.33352 18.8822 2.48669L8.65887 12.4556C8.50079 12.6088 8.2459 12.6088 8.08882 12.4556Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.08882 18.8853L1.11783 12.0887C0.960722 11.9355 0.960722 11.6861 1.11783 11.5329L2.9801 9.71693C3.13818 9.56376 3.39307 9.56376 3.55015 9.71693L7.63929 13.7043C8.04535 14.1002 8.70231 14.1002 9.10738 13.7043L16.4498 6.54457C16.6069 6.39139 16.8618 6.39139 17.0199 6.54457L18.8822 8.36049C19.0393 8.51464 19.0393 8.76318 18.8822 8.91638L8.65887 18.8853C8.50079 19.0385 8.2459 19.0385 8.08882 18.8853Z",
  fill: "currentColor"
});

var SvgDoubleTick = function SvgDoubleTick(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoubleTick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doubleTick.175af57e.svg";
export { ForwardRef as ReactComponent };